import { render, staticRenderFns } from "./login.vue?vue&type=template&id=585bdf08&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=585bdf08&prod&lang=scss&scoped=true"
import style1 from "./login.vue?vue&type=style&index=1&id=585bdf08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585bdf08",
  null
  
)

export default component.exports